/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';
import { IGraphDataV2Schema } from '../../entities/estimation_trend/GraphDataV2Schema';
import { IEstimationWithPriceInfoV2Schema } from '../../entities/estimation_trend/EstimationWithPriceInfoV2Schema';

export type TGetEstimationAndTrendWebModel = IModel<
  IGetEstimationAndTrendWebRequest,
  TGetEstimationAndTrendWebResponse
>;

export interface IGetEstimationAndTrendWebRequest {
  /** cian ID объявления **/
  cianOfferId?: number | null;
}

export type TGetEstimationAndTrendWebResponse =
  | IGetEstimationAndTrendWebResponse200
  | IGetEstimationAndTrendWebResponse400;

export interface IGetEstimationAndTrendWebResponse200 extends IModelResponse<IGetEstimationAndTrendWebResponse> {
  statusCode: 200;
}

export interface IGetEstimationAndTrendWebResponse400 extends IModelResponse<IGetEstimationAndTrendWebResponseError> {
  statusCode: 400;
}

export interface IGetEstimationAndTrendWebResponse {
  /** Доступные временные интервалы оценки **/
  estimationPeriods: EEstimationPeriods[];
  /** Графики изменения рыночной цены и оценки **/
  graphs: IGraphDataV2Schema[];
  /** Общая информация об оценке квартиры **/
  priceInfo?: IEstimationWithPriceInfoV2Schema | null;
}

export interface IGetEstimationAndTrendWebResponseError {
  errors: any[];
  message: string;
}

export type TResponses = IGetEstimationAndTrendWebResponse | IGetEstimationAndTrendWebResponseError;

export enum EEstimationPeriods {
  /** Для блока оценки за пол года **/
  EstimatePeriodHalfYear = 'estimatePeriodHalfYear',
  /** Для блока оценки за месяц **/
  EstimatePeriodMonth = 'estimatePeriodMonth',
  /** Для блока оценки за неделю **/
  EstimatePeriodWeek = 'estimatePeriodWeek',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: IGetEstimationAndTrendWebResponse): TResponse200;
  400(response: IGetEstimationAndTrendWebResponseError): TResponse400;
}
